(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("InputMask", [], factory);
	else if(typeof exports === 'object')
		exports["InputMask"] = factory();
	else
		root["InputMask"] = factory();
})(this, function() {
return 